import React from 'react'

const Manual_invuKDS_configuracion_agrupacion_flujo = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          InvuKDS Configuración - Agrupación y Flujo
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Al ajustar configuraciones como la agrupación de pedidos, el orden de visualización y los
          resúmenes de artículos, los usuarios pueden personalizar cómo aparecen los pedidos en la
          pantalla KDS, mejorando la eficiencia del flujo de trabajo.
        </p>
        <iframe
          src="https://scribehow.com/embed/InvuKDS_Configuracion__Agrupacion_y_Flujo__ohKK_WfeSoeaCw6H-ZqfaQ?as=scrollable"
          className="scribe-iframe-general-8"
          width="100%"
          height="5000"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_invuKDS_configuracion_agrupacion_flujo